export const dropIfNotChanged = (
  current,
  originalObject,
  key,
  mapper = x => x
) =>
  originalObject && current === mapper(originalObject[key])
    ? undefined
    : current;
// Fixme: it does not work for array and other kind of more advanced objects (because of comparing using === operator)
